import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth/auth.service";
import { ExceptionsService } from "src/app/exceptions/exceptions.service";
import { AlertService } from "src/app/services/alert/alert.service";
import { LoaderService } from "src/app/services/loader/loader.service";
import firebase from 'firebase/app';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { RouterService } from "src/app/services/router/router.service";
import { ModalController } from "@ionic/angular";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit {
  changePasswordForm: FormGroup;
  messageError: Promise<string>;
  LOADER_ID = "change-email";

  fieldTextType: boolean;
  repeatFieldTextType: boolean;

  fieldTextType2: boolean;
  repeatFieldTextType2: boolean;

  fieldTextType3: boolean;
  repeatFieldTextType3: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private exceptionService: ExceptionsService,
    private alertService: AlertService,
    private loaderService: LoaderService,
    public languageService: LanguagesService,
    private routerService: RouterService,
    public modalController: ModalController,
  ) {
    this.changePasswordForm = this.formBuilder.group({
      passwordOld: ["",
        Validators.compose([Validators.required, Validators.minLength(8),
        ]),
      ],
      password: ["",
        Validators.compose([Validators.required, Validators.minLength(8)]),
      ],
      rePassword: ["",
        Validators.compose([Validators.required, Validators.minLength(8)]),
      ],
    });
  }

  ngOnInit() {

  }
  async changePassword() {
    try {
      if (this.checkPasswords()) {
        this.loaderService.presentLoading(this.LOADER_ID);
        const { passwordOld, password } = this.changePasswordForm.value;
        const userFirebase: firebase.User = await this.authService.getUSerInfoFromFirebase();

        if (await this.authService.loginWithUserAndPassword(userFirebase.email, passwordOld)) {
          await userFirebase.updatePassword(password);
          this.loaderService.cancelLoader(this.LOADER_ID);
          this.alertService.presentAlert("Cambio de contraseña aceptado");
          // @TODO Cerrar modal cuando cambie la contraseña
          this.alertService.dismissPopup();
          return this.routerService.redirect("app/home");

        }
      }
    } catch (err) {
      this.loaderService.cancelLoader(this.LOADER_ID);
      console.log(err);
      this.exceptionService.renderError(err);
    }
  }

  get getInputError() {
    return this.languageService.textsIU.input_error;
  }
  get getTextIUPageChangePassword() {
    return this.languageService.textsIU.page_change_password;
  }

  checkPasswords() {
    const { password, rePassword } = this.changePasswordForm.value;
    return password === rePassword;
  }


  messageErrorRePassword() {
    const rePassword = this.changePasswordForm.get("rePassword").value;
    return !this.checkPasswords() && rePassword.length >= 8;
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  toggleRepeatFieldTextType() {
    this.repeatFieldTextType = !this.repeatFieldTextType;
  }

  toggleFieldTextType2() {
    this.fieldTextType2 = !this.fieldTextType2;
  }

  toggleRepeatFieldTextType2() {
    this.repeatFieldTextType2 = !this.repeatFieldTextType2;
  }

  toggleFieldTextType3() {
    this.fieldTextType3 = !this.fieldTextType3;
  }

  toggleRepeatFieldTextType3() {
    this.repeatFieldTextType3 = !this.repeatFieldTextType3;
  }
}


